import request from './base'

export default {
  /**
   * 广告位列表
   */
  queryAdSlot: (commit, payload, mutation) => {
    let options = request.getOptions('/ad/slot/query', payload)
    return request.post(commit, options, mutation)
  },
  /**
   * 素材列表（分页）
   * payload: {
   *   pageNum: 1,
   *   pageSize: 10,
   *   dto: { slotId: '', advertiser: '', creativeName: '', status: '' }
   * }
   */
  queryPageAdCreative: (commit, payload, mutation) => {
    let options = request.getOptions('/ad/creative/queryPage', payload)
    return request.post(commit, options, mutation)
  },
  /**
   * 素材新增/编辑（合并接口，有 creativeId 为编辑）
   * payload: {
   *   dto: {
   *     creativeId: '', slotId: '', advertiser: '', creativeName: '',
   *     imageUrl: '', linkType: 1, targetUrl: '', startTime: '', endTime: '', sort: 0, status: 1
   *   }
   * }
   */
  addorupdateAdCreative: (commit, payload, mutation) => {
    let options = request.getOptions('/ad/creative/addorupdate', payload)
    return request.post(commit, options, mutation)
  },
  /**
   * 素材删除
   */
  deleteAdCreative: (commit, payload, mutation) => {
    let options = request.getOptions('/ad/creative/delete', payload)
    return request.post(commit, options, mutation)
  },
  /**
   * 效果总览
   * payload: { startDate, endDate, slotCode, advertiser }
   */
  overviewAdStat: (commit, payload, mutation) => {
    let options = request.getOptions('/adstat/overview', payload)
    return request.post(commit, options, mutation)
  },
  /**
   * 趋势
   */
  trendAdStat: (commit, payload, mutation) => {
    let options = request.getOptions('/adstat/trend', payload)
    return request.post(commit, options, mutation)
  },
  /**
   * 广告位/素材明细（分页）
   */
  pageAdStat: (commit, payload, mutation) => {
    let options = request.getOptions('/adstat/page', payload)
    return request.post(commit, options, mutation)
  },
  /**
   * 报表数据（scope: slot | advertiser | all）
   * payload: { startDate, endDate, slotCode, advertiser, scope, sourceSlotName }
   */
  reportDataAdStat: (commit, payload, mutation) => {
    let options = request.getOptions('/adstat/reportData', payload)
    return request.post(commit, options, mutation)
  }
}



// WEBPACK FOOTER //
// ./src/services/ad.js